import { makeStyles } from "tss-react/mui"
import { useFormikContext } from "formik"
import { Grid } from "@mui/material"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { CreateUpdateDayMenuFormValues } from "../../menuPlanningTypes"
import { FormikSelectColorField } from "./FormikSelectColorField"
import { SignageTypesField } from "./SignageTypesField"
import { RecurrenceList } from "./RecurrenceList"
import { DishList } from "./DishList"

const useStyles = makeStyles()(() => ({
    container: {
        marginBottom: "3rem",
        width: "36.25rem",
    },
}))
type CreateUpdateDayMenuFormContentProps = Readonly<{
    isEditMode: boolean
}>
export const AVAILABLE_DISH = 5

export const CreateUpdateDayMenuFormContent = ({ isEditMode }: CreateUpdateDayMenuFormContentProps) => {
    const { classes } = useStyles()
    const { values } = useFormikContext<CreateUpdateDayMenuFormValues>()
    const isDisabledSubmit = values.dishes[0].name.trim() === ""

    return (
        <>
            <Grid container flexDirection="column" gap={4} className={classes.container}>
                <RecurrenceList />
                <FormikSelectColorField />
                <SignageTypesField />
                <DishList />
            </Grid>
            <Grid container justifyContent="center">
                {isEditMode ? (
                    <LocalizedStrict id="merchant-menu-planning-dialog-save-submit-button">
                        <StandardButton type="submit" fullWidth={false} disabled={isDisabledSubmit}>
                            Save
                        </StandardButton>
                    </LocalizedStrict>
                ) : (
                    <LocalizedStrict id="merchant-menu-planning-dialog-create-submit-button">
                        <StandardButton type="submit" fullWidth={false} disabled={isDisabledSubmit}>
                            Create
                        </StandardButton>
                    </LocalizedStrict>
                )}
            </Grid>
        </>
    )
}
